import FootballStringifier from "../../../../../services/stringifiers/football-stringifier";
import Rule from "../../../../common/rule";
import FootballState from "../../../state/football-state";

export default class PatDefenseComplete extends Rule {
    // eslint-disable-next-line no-unused-vars
    applicable(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        const { summaryContext } = FootballStringifier.generateSummary(
            play,
            gameContext
        );
        const { gameConfig } = gameContext;
        const { homeTeamHasPossession, fieldPosition } = summaryContext;
        const { homeTeamHasPossession: homeTeamPat } = play.contextSnapshot;
        const { fieldLength } = gameConfig.general;

        const isInZone = homeTeamHasPossession
            ? fieldPosition >= fieldLength
            : fieldPosition <= 0;

        return (
            ruleContext.PAT &&
            [FootballState.EndOfPlay, FootballState.NoPenaltyEndOfPlay].some(
                (state) => state === fragment.associatedState
            ) &&
            homeTeamHasPossession !== homeTeamPat &&
            isInZone
        );
    }

    // eslint-disable-next-line no-unused-vars
    async apply(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        const { homeTeamHasPossession, homeTeamId, awayTeamId } =
            play.contextSnapshot;
        const defensiveTeamId = homeTeamHasPossession ? awayTeamId : homeTeamId;

        gameContext.setPossessionForTeamId(defensiveTeamId);

        const { defensivePAT: points } = gameContext.gameConfig.scoring || {
            defensivePAT: 0
        };

        gameContext.increaseTeamPossessionScore(points);
        ruleContext.playPoints = points;
        gameContext.setPossessionForTeamId(
            homeTeamHasPossession ? homeTeamId : awayTeamId
        );
    }
}
